export default __webpack_public_path__ + "static/media/2865545.1258bd2c.png";